import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { MatPaginator, MatSort } from "@angular/material"
import { Observable } from 'rxjs';
import { SearchComponent } from "../../pillar/search/components/search.component";
import { Subject } from "rxjs/Subject";
import { PageRequestModel } from "../models/PageRequestModel";

export class PageEventDataSource<TModel> implements DataSource<TModel> {

  constructor(
    private destroyed$: Subject<boolean>,
    public paginator: MatPaginator,
    private pagedItems$: Observable<TModel[]>,
    private totalCount$: Observable<number>,
    private loading$: Observable<boolean>,
    private pageEvent: (pageRequest: PageRequestModel) => void,
    public sort?: MatSort | null,
    public search?: SearchComponent | null) {
    if (paginator) {
      paginator.page.takeUntil(destroyed$)
        .subscribe(() => {
          this.sendPageEvent();
        });

      totalCount$.takeUntil(destroyed$).subscribe(value => {
        this.paginator.length = value;
        if (this.paginator.pageIndex > 0) {
          const lastPageIndex = Math.ceil(this.paginator.length / this.paginator.pageSize) - 1 || 0;
          this.paginator.pageIndex = Math.min(this.paginator.pageIndex, lastPageIndex);
        }
      });
    }
    if (sort) {
      sort.sortChange.takeUntil(destroyed$)
        .subscribe(() => {
          this.sendPageEvent();
        });
    }
    if (search) {
      search
        .searchControl
        .valueChanges
        .debounceTime(500)
        .takeUntil(destroyed$)
        .subscribe(() => {
          this.sendPageEvent();
        });
    }
  }

  connect(collectionViewer: CollectionViewer): Observable<TModel[]> {
    this.sendPageEvent();
    return this.pagedItems$;
  }

  disconnect(collectionViewer: CollectionViewer): void {
    if (this.paginator) {
      this.paginator.page.unsubscribe();
    }
  }

  private sendPageEvent(): void {      
    var pageRequest = new PageRequestModel();
    pageRequest.page = this.paginator.pageIndex;
    pageRequest.pageSize = this.paginator.pageSize;
    pageRequest.sort = this.sort.active;
    pageRequest.sortDirection = this.sort.direction;
    pageRequest.searchTerm = this.search.searchControl.value;
    this.pageEvent(pageRequest);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/PageEventDataSource.ts